import {docs} from '~/config'
import {EitjeButton} from '../components'

export const DocsButton = ({collection, to, t = 'common.explanation', ...rest}) => {
	const condOpts = docs?.useDocsLink({collection, to})

	return (
		<EitjeButton
			data-intercom-target="docs_button"
			className="docs-button"
			colorSet="solid"
			baseColor="pink"
			t={t}
			{...rest}
			{...condOpts}
		/>
	)
}
